import { render, staticRenderFns } from "./TDetailsItem.vue?vue&type=template&id=7de5302c&scoped=true&"
import script from "./TDetailsItem.vue?vue&type=script&lang=js&"
export * from "./TDetailsItem.vue?vue&type=script&lang=js&"
import style0 from "./TDetailsItem.vue?vue&type=style&index=0&id=7de5302c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de5302c",
  null
  
)

/* custom blocks */
import block0 from "./TDetailsItem.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports